import GuideLayout from '@/pages/shared/GuideLayout';

export default function GuideGantt() {
  return (
    <GuideLayout
      title="ガントチャートとは？作り方とおすすめツールの選び方｜”おもいむすび”"
      description="ガントチャートの基本を解説。ガントチャートとは何か、作り方、メリット、Excelでの作成方法、依存関係やマイルストーンの設定、おすすめのガントチャートツールの選び方まで。"
      keywords="プロジェクト管理 ガントチャート,ガントチャートとは,ガントチャート 作り方,ガントチャート ツール,ガントチャート Excel"
      canonical="https://omoimusubi.asia/guides/gantt-chart/"
      h1="ガントチャートとは？作り方とツールの選び方"
      subtitle="ガントチャートの基本概念と作り方、プロジェクト管理における活用方法、ツールの選び方について詳しく解説します。"
      relatedFeatures={[
        { label: 'AIガントチャート', path: '/features/ai-gantt/' },
        { label: 'AIタスク分解', path: '/features/ai-task-breakdown/' },
      ]}
      relatedGuides={[
        { label: 'WBSとガントチャートの違い', path: '/guides/wbs-and-gantt-chart/' },
        { label: 'ガントチャートツール比較', path: '/compare/gantt-chart-tools/' },
        { label: 'ガントチャートExcelテンプレート', path: '/templates/gantt-chart-excel/' },
        { label: 'クリティカルパスとは', path: '/guides/critical-path/' },
      ]}
    >
      <div className="not-prose mb-8 rounded-xl overflow-hidden border border-background-200/70">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20Japanese%20office%20a%20Japanese%20male%20project%20manager%20in%20his%2030s%20sitting%20at%20a%20clean%20wooden%20desk%20with%20a%20large%20monitor%20displaying%20a%20colorful%20detailed%20gantt%20chart%20with%20horizontal%20task%20bars%20in%20different%20colors%20showing%20project%20timeline%20he%20is%20reviewing%20the%20chart%20with%20a%20focused%20expression%20natural%20daylight%20streaming%20through%20windows%20indoor%20plants%20refreshing%20organized%20contemporary%20Japanese%20workspace&width=1200&height=600&seq=guide-gantt-01&orientation=landscape"
          alt="ガントチャートとは - ガントチャートを確認する日本人プロジェクトマネージャー"
          className="w-full h-auto"
        />
      </div>
      <section>
        <h2>ガントチャートとは</h2>
        <p>ガントチャート（Gantt Chart）とは、プロジェクトのタスクや作業を時系列で横棒グラフとして表現した図です。各タスクの開始日、終了日、所要期間、担当者、依存関係を一目で把握できるため、プロジェクト管理において最も広く使われているツールの一つです。</p>
      </section>

      <section>
        <h2>ガントチャートの主な構成要素</h2>
        <ul>
          <li><strong>タスクバー</strong>：各タスクの期間を横棒で表示</li>
          <li><strong>マイルストーン</strong>：重要な節目をひし形で表示</li>
          <li><strong>依存関係の矢印</strong>：タスク間の前後関係を矢印で表現</li>
          <li><strong>進捗率</strong>：各タスクの完了度合いを表示</li>
          <li><strong>ベースライン</strong>：当初計画と現在計画の比較線</li>
        </ul>
      </section>

      <section>
        <h2>AIによるガントチャート自動作成</h2>
        <p>従来、ガントチャートの作成には多くの手作業が必要でしたが、”おもいむすび”のAIガントチャートでは、AIが提案したタスクをもとにガントチャートを自動生成します。依存関係の矢印、マイルストーン、予実比較なども自動で設定され、日報と連動して進捗が自動更新されます。</p>
      </section>
    </GuideLayout>
  );
}